(function () {
const MONEY = new Intl.NumberFormat('de-CH', { style: 'currency', currency: 'CHF' });

function formatMoney(cents) {
return MONEY.format((cents || 0) / 100);
}

function ensureSummary(container) {
if (!container) return null;

// próbáljuk a gombok fölé tenni
const buttons =
  container.querySelector('.cart-notification__links') ||
  container.querySelector('.cart-drawer__footer') ||
  container.querySelector('form[action^="/cart"]');

let summary = container.querySelector('.snus-cart-summary');
if (!summary) {
  summary = document.createElement('div');
  summary.className = 'snus-cart-summary';
  summary.innerHTML = `
    <div>
      <div><strong>Warenkorb</strong></div>
      <small class="snus-cart-count">–</small>
    </div>
    <div class="snus-cart-total">–</div>
  `;
  if (buttons && buttons.parentNode) {
    buttons.parentNode.insertBefore(summary, buttons);
  } else {
    container.prepend(summary);
  }
}
return summary;

}

async function updateCartUI() {
let cart;
try {
const res = await fetch('/cart.js', { credentials: 'same-origin' });
cart = await res.json();
} catch (e) {
return;
}

const countText = `${cart.item_count || 0} Artikel`;
const totalText = formatMoney(cart.total_price);

const containers = [
  document.querySelector('.cart-notification'),
  document.querySelector('cart-drawer'),
  document.querySelector('.cart-drawer'),
  document.querySelector('.drawer')
].filter(Boolean);

containers.forEach((c) => {
  const summary = ensureSummary(c);
  if (!summary) return;

  const countEl = summary.querySelector('.snus-cart-count');
  const totalEl = summary.querySelector('.snus-cart-total');

  if (countEl) countEl.textContent = countText;
  if (totalEl) totalEl.textContent = totalText;
});

}

// figyeljük amikor megnyílik a drawer / popup
function observeOpen() {
const observer = new MutationObserver(() => {
// amikor változik a DOM, frissítünk
updateCartUI();
});

observer.observe(document.documentElement, {
  childList: true,
  subtree: true
});

}

document.addEventListener('DOMContentLoaded', function () {
updateCartUI();
observeOpen();
});

// ha Dawn eseményt küld, arra is ráülünk (nem baj, ha nincs)
document.addEventListener('cart:refresh', updateCartUI);
document.addEventListener('cart:updated', updateCartUI);
})();